// extracted by mini-css-extract-plugin
module.exports = {"modal":"_1kFK4OnRMZVL7SEQBIHYA3","text-underline":"_1qaMnNGuBZUHDc2IY6zFcj","small-text":"_37vPj_tV3QLaipwIIPK3qV"};